const state = {
    benchmarks: {
        list: {},
        cnt: 0,
        selected: null,
    },
};

const mutations = {
    ADD_BENCHMARKS_TO_LIST: (state, benchmark) => {
        Vue.set(state.benchmarks.list, benchmark.id, {...state.benchmarks.list[benchmark.id], ...benchmark});
    },
    SET_BENCHMARKS: (state, benchmarks) => {
        Vue.set(state, 'benchmarks', benchmarks);
    },
    SET_SELECTED_BENCHMARK: (state, selectedBenchmarkId) => {
        Vue.set(state.benchmarks, 'selected', selectedBenchmarkId);
    },
};

const getters = {
    GET_BENCHMARKS: (state) => state.benchmarks,
    GET_SELECTED_BENCHMARK_ID: (state) => state.benchmarks.selected,
};

export default {
    state,
    mutations,
    getters
}